import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueAnalytics from 'vue-analytics'
import { firestorePlugin } from 'vuefire'


Vue.config.productionTip = false

// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(firestorePlugin)
Vue.use(VueAnalytics, {
    id: 'UA-110665184-7'
})
Vue.use(VueAwesomeSwiper)

Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')